import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";

function ComprasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;

  const URL_PROVEEDORES = import.meta.env.VITE_URL_PROVEEDORES;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const AREA_BODEGA = import.meta.env.VITE_AREA_BODEGA;
  const URL_SEND_MAIL = import.meta.env.VITE_URL_SEND_MAIL;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
  const URL_COMPRAS = import.meta.env.VITE_URL_COMPRAS;
  const URL_ARTICULOS_PROPORCION = import.meta.env
    .VITE_URL_ARTICULOS_PROPORCION;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [idsArticulos, setIdsArticulos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const NOMBRE_BODEGA_DEFAULT = "Bodega Gloss";

  const [selectedArea, setSelectedArea] = useState("");
  // Nombre del almacen destino resuelto (Bodega Gloss). Si queda vacio, la
  // captura se bloquea: nunca se ofrece elegir otro almacen.
  const [areaFijaNombre, setAreaFijaNombre] = useState("");
  const [errorAreaBodega, setErrorAreaBodega] = useState(false);

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [fecha, setFecha] = useState(hoy);
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);

  const [total_cantidad, setTotalCantidad] = useState(0);
  const [codigoEscaneadoPrueba, setCodigoEscaneadoPrueba] = useState("");
  const [inputFields, setInputFields] = useState([
    // {
    //   id: uuidv4(),
    //   articulos: "",
    //   cantidad: 0,
    //   precio: 0,
    //   precioOriginal: 0,
    //   total: 0,
    //   articulosNombre: "",
    //   idColor: "",
    //   colorNombre: "",
    //   idTalla: "",
    //   tallaNombre: "",
    //   colores: [],
    //   tallas: [],
    // },
  ]);
  const [expandedTables, setExpandedTables] = useState({});

  const [manualInput, setManualInput] = useState({
    articulosNombre: "",
    articulos: "",
    idColor: "",
    idTalla: "",
    tallaNombre: "",
    cantidad: 0,
    precio: 0,
    colores: [],
    tallas: [],
    total: 0,
  });

  // Ref para el input del scanner (uncontrolled para evitar race conditions con la pistola)
  const scannerInputRef = useRef(null);
  const [proporcionScannerInput, setProporcionScannerInput] = useState("");

  const handleManualArticuloChange = (selectedArticulo) => {
    if (selectedArticulo) {
      setManualInput({
        articulos: selectedArticulo._id,
        articulosNombre: selectedArticulo.codigo + selectedArticulo.nombre,
        precio: selectedArticulo.costoMX,
        colores: selectedArticulo.colores,
        tallas: selectedArticulo.tallas,
        idColor: "",
        idTalla: "",
        cantidad: 0,
        idProporcion: "",
      });
    }
  };

  const ActualizaTotales = useCallback(() => {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);

    setTotalGeneral(TG);
  }, [inputFields, setTotalCantidad, setSubTotal, setTotalGeneral]);

  useEffect(() => {
    ActualizaTotales();
  }, [inputFields, ActualizaTotales]);

  const handleManualInputChange = (event) => {
    const { name, value } = event.target;

    setManualInput((prev) => {
      const updatedInput = {
        ...prev,
        [name]: value,
      };

      // If changing talla, update tallaNombre
      if (name === "idTalla") {
        const selectedTalla = prev.tallas.find((t) => t._id === value);
        updatedInput.tallaNombre = selectedTalla ? selectedTalla.name : "";
      }

      // Calculate total whenever cantidad changes
      if (name === "cantidad") {
        updatedInput.cantidad = parseFloat(value);
        updatedInput.total = parseFloat(value) * prev.precio;
      }

      return updatedInput;
    });
  };

  const handleManualAdd = async () => {
    if (
      !manualInput.articulosNombre ||
      !manualInput.idColor ||
      !manualInput.idTalla ||
      !manualInput.cantidad
    ) {
      return;
    }

    let res;

    try {
      res = await axios.get(
        `${URL_ARTICULOS_PROPORCION}/ArticuloColorTalla/${manualInput.articulos}/${manualInput.idColor}/${manualInput.idTalla}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
    } catch (err) {
      console.log(err);
    }

    if (!res) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se encontró el artículo con la talla y color seleccionados",
        showConfirmButton: false,
      });
      return;
    }
    const idArticuloProporcion = res.data[0]._id;

    const avaible = inputFields.find(
      (i) => i.idArticuloProporcion === idArticuloProporcion
    );

    if (avaible) {
      // Create new array with updated object
      const updatedFields = inputFields.map((field) => {
        if (field.idArticuloProporcion === idArticuloProporcion) {
          return {
            ...field,
            cantidad: field.cantidad + manualInput.cantidad,
            total: (field.cantidad + manualInput.cantidad) * field.precio,
          };
        }
        return field;
      });

      setInputFields(updatedFields);
      // Reset only specific fields after adding
      setManualInput((prev) => ({
        ...prev,
        idColor: "",
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        idTalla: "",
        tallaNombre: "",
        total: 0,
        idProporcion: "",
      }));

      return null;
    }

    const selectedColor = manualInput.colores.find(
      (c) => c._id === manualInput.idColor
    );
    const selectedTalla = manualInput.tallas.find(
      (t) => t._id === manualInput.idTalla
    );

    const newField = {
      id: uuidv4(),
      articulos: manualInput.articulos,
      articulosNombre: manualInput.articulosNombre,
      precio: manualInput.precio,
      cantidad: parseFloat(manualInput.cantidad),
      idTalla: manualInput.idTalla,
      tallaNombre: selectedTalla ? selectedTalla.name : "",
      idColor: manualInput.idColor,
      colorNombre: selectedColor ? selectedColor.name : "",
      total: manualInput.cantidad * manualInput.precio,
      colores: manualInput.colores,
      tallas: manualInput.tallas,
      idArticuloProporcion: idArticuloProporcion,
    };

    setInputFields((prev) => [...prev, newField]);

    // Reset only specific fields after adding
    setManualInput((prev) => ({
      ...prev,
      idColor: "",
      articulos: "",
      articulosNombre: "",
      cantidad: 0,
      idTalla: "",
      tallaNombre: "",
      precio: 0,
      total: 0,
      idProporcion: "",
    }));
  };

  const [inputArticulos, setInputArticulos] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cajas: 0,
      precio: 0,
      articulosNombre: "",
      colores: [],
      tallas: [],
      EAN: "",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  const [mailAutEnviado, setMailAutEnviado] = useState(false);
  const [randomCambiaPrecio, setRandomCambiaPrecio] = useState(
    (Math.random() + 1).toString(36).substring(2)
  );

  // Normaliza para comparar nombres de areas sin acentos, mayusculas ni
  // espacios de mas ("BODEGA  Gloss" === "Bodega Gloss").
  const normalizaNombre = (texto) =>
    (texto || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");

  // Toda la mercancia entra a Bodega Gloss, asi que el almacen destino se fija
  // automaticamente y no se ofrece ninguna otra opcion: si no se resuelve, se
  // bloquea la captura en lugar de arriesgar una entrada al almacen equivocado.
  // VITE_AREA_BODEGA permite fijar el area por id sin depender del nombre.
  const cargarAreaBodega = () => {
    setErrorAreaBodega(false);

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;

        const buscada = normalizaNombre(NOMBRE_BODEGA_DEFAULT);
        // La coincidencia parcial solo se acepta si es unica: con dos areas
        // como "Bodega Gloss Norte" y "Bodega Gloss Sur" no hay forma de saber
        // cual es, y adivinar mandaria la entrada al almacen equivocado.
        const parciales = allAreas.filter((a) =>
          normalizaNombre(a.name).includes(buscada)
        );
        const bodega =
          allAreas.find((a) => a._id === AREA_BODEGA) ||
          allAreas.find((a) => normalizaNombre(a.name) === buscada) ||
          (parciales.length === 1 ? parciales[0] : undefined);

        if (bodega) {
          setSelectedArea(bodega._id);
          setAreaFijaNombre(bodega.name);
        } else {
          // Ayuda para ambientes de prueba: deja ver que areas si existen para
          // poder fijar VITE_AREA_BODEGA con una de ellas.
          console.warn(
            `No se encontro el area "${NOMBRE_BODEGA_DEFAULT}". Areas disponibles:`,
            allAreas.map((a) => `${a.name} (${a._id})`)
          );
          setSelectedArea("");
          setAreaFijaNombre("");
          setErrorAreaBodega(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setSelectedArea("");
        setAreaFijaNombre("");
        setErrorAreaBodega(true);
      });
  };

  useMemo(() => {
    axios
      .get(`${URL_ARTICULOS}Activos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
        let result = allArticulos.map((a) => a._id);
        setIdsArticulos(result);
      })
      .catch((err) => {
        console.log(err);
      });

    cargarAreaBodega();

    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const savePedido = async (event) => {
    try {
      event.preventDefault();
      // Filter out empty items
      const validItems = inputFields.filter(
        (a) => a.articulos !== "" && a.cantidad !== 0
      );
      // Make a single API call with all data
      const response = await axios.post(
        `${URL_COMPRAS}Batch`,
        {
          fecha,
          total_cantidad,
          total_costo: total_general,
          user: user.id,
          areas: selectedArea,
          proveedores: selectedProveedor, // Note: backend uses provedoor
          // Send all items in a single request
          items: validItems.map((a) => ({
            articulos: a.articulos,
            cantidad: parseFloat(a.cantidad),
            colores: a.idColor,
            tallas: a.idTalla,
            costoPieza: a.precio,
            articulosProporcion: a.idArticuloProporcion,
            ubicacion: a.ubicacion || "Almacen",
          })),
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // Create a single log entry for the entire purchase
      await axios.post(
        URL_LOGS,
        {
          tipo: "Compra",
          detalle: `Compra completada - ${validItems.length} artículos, total: ${total_cantidad}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);

      // Handle success - can display notification or redirect
      console.log("Purchase saved successfully:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error saving purchase:", error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Algo salio mal",
      });
      // Handle error - display notification to user
      throw error;
    }
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        precio: 0,
        total: 0,
        articulosNombre: "",
        idColor: "",
        colorNombre: "",
        idTalla: "",
        tallaNombre: "",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalCan = values.map((c) => parseFloat(c.cantidad));
    let TC = totalCan.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    setTotalGeneral(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        i.precio = event.target.value;
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
    ActualizaTotales();
  };

  function BuscaCodigoProporcion(id, event) {
    const scanValue = event.target.value;

    // Only validate that scan value exists
    if (!scanValue) {
      return;
    }

    // Buscar por EAN o por _id (algunos códigos de barras contienen el _id)
    let foundArticle = articulos.find((a) => a.EAN === scanValue);
    if (!foundArticle) {
      foundArticle = articulos.find((a) => a._id === scanValue);
    }

    if (foundArticle) {
      const idArticulo = foundArticle._id;
      const articulosNombre = `${foundArticle.codigo} ${foundArticle.nombre}`;
      const colores = foundArticle.colores;
      const tallas = foundArticle.tallas;
      const precio = foundArticle.costoMX;

      handleChangeInputArticuloProporcion(
        id,
        idArticulo,
        precio,
        articulosNombre,
        colores,
        tallas,
        scanValue
      );

      // Clear the proporcion scanner input after successful scan
      setProporcionScannerInput("");
    } else {
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
      // Also clear the input on error so user can try again
      setProporcionScannerInput("");
    }
  }

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cantidad = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    piezasPorCaja,
    precio,
    articulosNombre,
    colores,
    tallas
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        i.precio = precio;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.articulosNombre = articulosNombre;
        i.colores = colores;
        i.tallas = tallas;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
    handleAddFields();
  };

  const options = articulos.map((option) => {
    const junta = option.codigo;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function autorizaCambio() {
    if (password === randomCambiaPrecio) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
      Swal.fire("Good job!", "Se autorizo con exito", "success");
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function solicitarAut() {
    setMailAutEnviado(true);

    axios.post(
      `${URL_WHATSAPP}SendMsg`,
      {
        number: import.meta.env.VITE_TELEFONO_SUPER_ADMIN,
        message: `Hola,
El Vendedor ${user.nombre} ${user.apellido} esta solicitando un cambio de precio.
Si lo autorizas proporciona la clave:
${randomCambiaPrecio}`,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    axios
      .post(
        URL_SEND_MAIL,
        {
          subject: "Cambio de Precio",
          email: import.meta.env.VITE_EMAIL_SUPER_ADMIN,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
       <th><img width="${
         import.meta.env.VITE_TAMANO_LOGO_MAIL
       }" align="center" src="${
            import.meta.env.VITE_LINK_SISTEMA
          }logoInstitucion.png" /></th>
       <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${
         import.meta.env.VITE_NOMBRE_INSTITUCION
       }</tr>
       <tbody>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>El vendedor ${
         user.nombre
       } ${
            user.apellido
          } esta solicitando un cambio de precio, si lo autorizas proporciona la clave ${randomCambiaPrecio}</tr>
       </tbody>
       <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${
         import.meta.env.VITE_TELEFONO_INSTITUCION
       }</tr>
       <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${
         import.meta.env.VITE_LINK_SISTEMA
       }Logo-Sistemify-PDF.png" /> </a> </tr>
       </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  const handleChangeInputProporcion = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function BuscaArticuloProporcion(id, selectedArticulo) {
    const foundArticle = articulos.find((a) => a._id === selectedArticulo._id);

    if (foundArticle) {
      const idArticulo = selectedArticulo._id;
      const articulosNombre = `${selectedArticulo.codigo} ${selectedArticulo.nombre}`;
      const colores = foundArticle.colores;
      const tallas = foundArticle.tallas;
      const precio = foundArticle.costoMX;
      const EAN = foundArticle.EAN;

      handleChangeInputArticuloProporcion(
        id,
        idArticulo,
        precio,
        articulosNombre,
        colores,
        tallas,
        EAN
      );
    } else {
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
    }
  }
  // Sanitizar código de barras para comparación consistente
  const sanitizeBarcode = (code) => {
    if (!code) return "";
    return code
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase()
      .trim();
  };

  async function buscarArticuloSingular(rawScanValue) {
    const scanValue = rawScanValue.trim();
    const sanitizedValue = sanitizeBarcode(scanValue);
    setCodigoEscaneadoPrueba(scanValue);

    // Only validate that scan value exists
    if (!scanValue) {
      return;
    }

    // Función auxiliar para buscar artículo
    const buscarArticulo = async () => {
      // Primero intentar por EAN exacto
      try {
        const resByEAN = await axios.get(
          `${URL_ARTICULOS_PROPORCION}/EAN/${scanValue}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_token")}`,
            },
          }
        );
        if (resByEAN.data) return resByEAN;
      } catch (error) {
        // EAN exacto no encontrado
      }

      // Intentar por EAN sanitizado si es diferente
      if (sanitizedValue && sanitizedValue !== scanValue) {
        try {
          const resBySanitized = await axios.get(
            `${URL_ARTICULOS_PROPORCION}/EAN/${sanitizedValue}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_token")}`,
              },
            }
          );
          if (resBySanitized.data) return resBySanitized;
        } catch (error) {
          // EAN sanitizado tampoco encontrado
        }
      }

      // Si no se encuentra y es un ObjectId válido, intentar por _id
      const isValidObjectId = /^[a-fA-F0-9]{24}$/.test(scanValue);
      if (isValidObjectId) {
        try {
          const resById = await axios.get(
            `${URL_ARTICULOS_PROPORCION}/${scanValue}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_token")}`,
              },
            }
          );
          if (resById.data) return resById;
        } catch (error) {
          // ID tampoco encontrado
        }
      }

      return null;
    };

    try {
      const res = await buscarArticulo();

      if (!res || !res.data) {
        throw new Error("No data received");
      }

      const {
        _id: idArticuloProporcion,
        articulos: [firstArticulo],
        colores,
        tallas,
      } = res.data;

      // Check if any required data is missing
      if (!firstArticulo || !colores.length || !tallas.length) {
        throw new Error("Invalid article data");
      }

      // Check for existing item
      const existingItem = inputFields.find((item) => item.EAN === scanValue);

      if (existingItem) {
        const updatedFields = inputFields.map((field) => {
          if (field.EAN === scanValue) {
            const newQuantity = field.cantidad + 1;

            setManualInput({
              articulos: firstArticulo._id,
              articulosNombre: `${firstArticulo.codigo} ${firstArticulo.nombre}`,
              precio: firstArticulo.costoMX,
              colores: colores,
              tallas: tallas,
              idColor: colores[0]._id,
              idTalla: tallas[0]._id,
              cantidad: 1,
              idProporcion: idArticuloProporcion,
            });
            return {
              ...field,
              cantidad: newQuantity,
              total: newQuantity * field.precio,
            };
          }
          return field;
        });
        setInputFields(updatedFields);
        // Input ya fue limpiado en el onKeyDown handler
        return;
      }

      // // Create new item
      // const newField = {
      //   id: uuidv4(),
      //   articulos: firstArticulo._id,
      //   articulosNombre: `${firstArticulo.codigo} ${firstArticulo.nombre}`,
      //   precio: firstArticulo.costoMX,
      //   cantidad: 1,
      //   idTalla: tallas[0]._id,
      //   tallaNombre: tallas[0].name,
      //   idColor: colores[0]._id,
      //   colorNombre: colores[0].name,
      //   EAN: scanValue,
      //   total: firstArticulo.costoMX,
      //   colores: colores,
      //   tallas: tallas,
      //   idArticuloProporcion: idArticuloProporcion,
      // };

      // setInputFields((prev) => [...prev, newField]);
      const newManualInput = {
        articulos: firstArticulo._id,
        articulosNombre: `${firstArticulo.codigo} ${firstArticulo.nombre}`,
        precio: firstArticulo.costoMX,
        colores: colores,
        tallas: tallas,
        idColor: colores[0]._id,
        idTalla: tallas[0]._id,
        cantidad: 1,
        idProporcion: idArticuloProporcion,
      };
      setManualInput(newManualInput);

      // Input ya fue limpiado en el onKeyDown handler
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
      // Input ya fue limpiado en el onKeyDown handler
    }
  }

  const handleChangeInputArticuloProporcion = (
    id,
    idArticulo,
    precio,
    articulosNombre,
    colores,
    tallas,
    ean
  ) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.precio = precio;
        i.articulosNombre = articulosNombre;
        i.cajas = 0;
        i.colores = colores;
        i.tallas = tallas;
        i.EAN = ean;
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
    ActualizaTotales();
  };

  function agregarProporcion(
    idArticulo,
    articulosNombre,
    precio,
    cajas,
    colores,
    tallas
  ) {
    axios
      .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;

        const avaible = inputFields.find((f) => f.articulos === idArticulo);
        if (avaible) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Ya existe este articulo en la lista",
            showConfirmButton: false,
          });
          return;
        }

        const newInputFields = allArticulos.map((i) => {
          return {
            id: uuidv4(),
            articulos: idArticulo,
            articulosNombre: articulosNombre,
            precio: precio,
            cantidad: cajas * i.cantidad,
            idTalla: i.tallas[0]._id,
            tallaNombre: i.tallas[0].name,
            idColor: i.colores[0]._id,
            colorNombre: i.colores[0].name,
            total: cajas * i.cantidad * precio,
            colores: colores,
            tallas: tallas,
            idArticuloProporcion: i._id,
            // Add a groupKey to help with visual grouping
            groupKey: `${articulosNombre}-${i.colores[0].name}`,
            isFirstInGroup: false, // We'll set this after sorting
          };
        });

        setInputFields((prevInputFields) => {
          const updatedInputFields = [...prevInputFields, ...newInputFields];

          // Sort using your existing order
          const sortedInputFields = updatedInputFields.sort((a, b) => {
            if (a.articulosNombre < b.articulosNombre) return -1;
            if (a.articulosNombre > b.articulosNombre) return 1;

            if (a.colorNombre < b.colorNombre) return -1;
            if (a.colorNombre > b.colorNombre) return 1;

            return (
              customSizeOrder.indexOf(a.tallaNombre) -
              customSizeOrder.indexOf(b.tallaNombre)
            );
          });

          // Mark first items in each group
          let currentGroup = "";
          sortedInputFields.forEach((field, index) => {
            if (field.groupKey !== currentGroup) {
              field.isFirstInGroup = true;
              currentGroup = field.groupKey;
            } else {
              field.isFirstInGroup = false;
            }
          });

          // Calculate totals
          const totalCantidad = sortedInputFields.reduce(
            (acc, curr) => acc + parseFloat(curr.cantidad),
            0
          );
          setTotalCantidad(totalCantidad);

          let importes = sortedInputFields.map((c) => parseFloat(c.total));
          let TG = importes.reduce((t, total) => t + total, 0);

          setTotalGeneral(TG);

          return sortedInputFields;
        });

        setInputArticulos([
          {
            id: uuidv4(),
            articulos: "",
            cajas: 0,
            precio: 0,
            articulosNombre: "",
            colores: [],
            tallas: [],
            EAN: "",
          },
        ]);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12 p-4">
          <h3 align="center">Nueva Entrada</h3>
          {/* <Form > */}
          <Row>
            <Col md={2}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
                required
              />
            </Col>
            <Col md={3}>
              <Label>Almacen Destino</Label>
              {errorAreaBodega ? (
                <>
                  <Input
                    type="text"
                    value="No disponible"
                    disabled
                    readOnly
                    style={{ borderColor: "#dc3545" }}
                  />
                  <small className="text-danger">
                    No se pudo cargar {NOMBRE_BODEGA_DEFAULT}. No captures la
                    entrada hasta resolverlo.
                  </small>
                  <br />
                  <Button
                    size="sm"
                    className="btn btn-danger mt-1"
                    onClick={cargarAreaBodega}
                  >
                    Reintentar
                  </Button>
                </>
              ) : (
                <Input
                  type="text"
                  value={areaFijaNombre || "Cargando..."}
                  disabled
                  readOnly
                />
              )}
            </Col>
            <Col md={2}>
              <Label>Proveedor</Label>
              <Input
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                }}
              >
                <option value="">Selecciona un Proveedor</option>
                {proveedores
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((p) => {
                    return <option value={p._id}>{p.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <br />
          <br />

          {/* FULL PRODUCT SECTION */}
          <h4 className="text-dark">
            <b>Agregar Caja</b>
          </h4>
          <>
            {/* QR Scanner Input */}
            <Row className=""></Row>

            {/* Proportion Input Section */}
            <Row className="">
              <Col md={2}>
                <Label className="mr-sm-2">Escanea el QR</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Selecciona</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cajas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio MEX</Label>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={2}>
                <Input
                  name="articulos"
                  type="string"
                  value={proporcionScannerInput} // Use the new proporcion scanner state
                  onChange={(event) =>
                    setProporcionScannerInput(event.target.value)
                  } // Update proporcion scanner state on change
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      BuscaCodigoProporcion(inputArticulos[0].id, event);
                    }
                  }}
                ></Input>
              </Col>
              <Col md={2}>
                <Autocomplete
                  size="small"
                  value={inputArticulos[0]?.articulosNombre || ""}
                  onChange={(event, selectedArticulo) => {
                    BuscaArticuloProporcion(
                      inputArticulos[0]?.id || "template",
                      selectedArticulo
                    );
                  }}
                  options={options.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option?.junta || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option._id}>
                      {option.codigo} {option.nombre}
                    </li>
                  )}
                />
              </Col>
              <Col md={2}>
                <Input
                  name="articulosNombre"
                  type="string"
                  placeholder="Articulo"
                  value={inputArticulos[0]?.articulosNombre || ""}
                  disabled
                />
              </Col>
              <Col md={1}>
                <Input
                  name="cajas"
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Cajas"
                  value={inputArticulos[0]?.cajas || ""}
                  required
                  onChange={(event) =>
                    handleChangeInputProporcion(
                      inputArticulos[0]?.id || "template",
                      event
                    )
                  }
                />
              </Col>
              <Col md={1}>
                <Input
                  name="precio"
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Precio"
                  value={inputArticulos[0]?.precio || ""}
                  required
                  onChange={(event) =>
                    handleChangeInputPrecio(
                      inputArticulos[0]?.id || "template",
                      event
                    )
                  }
                />
              </Col>
              <Col>
                <Button
                  size="sm"
                  className="btn"
                  color="success"
                  disabled={
                    !inputArticulos[0]?.articulos ||
                    !inputArticulos[0]?.cajas ||
                    !inputArticulos[0]?.precio
                  }
                  onClick={() =>
                    agregarProporcion(
                      inputArticulos[0]?.articulos,
                      inputArticulos[0]?.articulosNombre,
                      inputArticulos[0]?.precio,
                      inputArticulos[0]?.cajas,
                      inputArticulos[0]?.colores,
                      inputArticulos[0]?.tallas
                    )
                  }
                  tabindex="-1"
                >
                  Agregar
                </Button>
              </Col>
            </Row>

            {/* MANUAL PRODUCT SECTION */}
            <h4 className="text-dark">
              <b>Agregar Pieza</b>
            </h4>
            <Row className="">
              <Col md={2}>
                <Label className="mr-sm-2">
                  Escanea el QR {codigoEscaneadoPrueba}
                </Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Selecciona</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio MEX</Label>
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <Input
                  name="articulos"
                  type="text"
                  innerRef={scannerInputRef}
                  autoComplete="off"
                  placeholder="Escanear código"
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      event.stopPropagation();
                      const value = scannerInputRef.current?.value || "";
                      if (value.trim().length >= 2) {
                        buscarArticuloSingular(value);
                      }
                      if (scannerInputRef.current) {
                        scannerInputRef.current.value = "";
                      }
                    }
                  }}
                ></Input>
              </Col>
              <Col md={2}>
                <Autocomplete
                  size="small"
                  value={manualInput?.articulosNombre || ""}
                  onChange={(event, selectedArticulo) => {
                    handleManualArticuloChange(selectedArticulo);
                  }}
                  options={options.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option?.junta || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option._id}>
                      {option.codigo} {option.nombre}
                    </li>
                  )}
                />
              </Col>
              <Col md={2}>
                <Input
                  type="text"
                  value={manualInput?.articulosNombre || ""}
                  disabled
                />
              </Col>
              <Col md={1}>
                <Input
                  name="idColor"
                  type="select"
                  value={manualInput?.idColor || ""}
                  onChange={handleManualInputChange}
                >
                  <option value="">Selecciona Color</option>
                  {manualInput?.colores?.map((color) => (
                    <option key={color._id} value={color._id}>
                      {color.name}
                    </option>
                  ))}
                </Input>
              </Col>
              <Col md={1}>
                <Input
                  name="idTalla"
                  type="select"
                  value={manualInput.idTalla || ""}
                  onChange={handleManualInputChange}
                >
                  <option value="">Selecciona Talla</option>
                  {manualInput.tallas &&
                    manualInput.tallas.map((talla) => (
                      <option key={talla._id} value={talla._id}>
                        {talla.name}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={1}>
                <Input
                  name="cantidad"
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Cantidad"
                  value={manualInput?.cantidad || 0}
                  disabled={!manualInput?.idColor || !manualInput?.idTalla}
                  onChange={handleManualInputChange}
                />
              </Col>
              <Col md={1}>
                <Input
                  name="precio"
                  type="number"
                  value={manualInput?.precio || 0}
                  onChange={handleManualInputChange}
                />
              </Col>
              <Col>
                <Button
                  size="sm"
                  className="btn"
                  color="success"
                  onClick={handleManualAdd}
                  disabled={
                    !manualInput?.articulosNombre ||
                    !manualInput?.idColor ||
                    !manualInput?.idTalla ||
                    !manualInput?.cantidad
                  }
                  tabindex="-1"
                >
                  Agregar
                </Button>
              </Col>
            </Row>
          </>

          <br />
          <hr />

          <div>
            {Object.entries(
              inputFields
                .filter((field) => field.articulosNombre && field.articulos)
                .reduce((acc, field) => {
                  const key = `${field.articulosNombre}`;
                  if (!acc[key]) {
                    acc[key] = {
                      articuloInfo: {
                        articulosNombre: field.articulosNombre,
                        articulos: field.articulos,
                        availableTallas: Array.from(
                          new Set(
                            inputFields
                              .filter(
                                (f) =>
                                  f.articulosNombre === field.articulosNombre
                              )
                              .map((f) => f.tallaNombre)
                              .filter(Boolean)
                              .sort((a, b) => {
                                return (
                                  customSizeOrder.indexOf(a) -
                                  customSizeOrder.indexOf(b)
                                );
                              })
                          )
                        ),
                      },
                      colorGroups: [],
                    };
                  }

                  const existingColorIndex = acc[key].colorGroups.findIndex(
                    (item) => item.idColor === field.idColor
                  );

                  if (existingColorIndex === -1) {
                    acc[key].colorGroups.push({
                      id: field.id,
                      articulos: field.articulos,
                      articulosNombre: field.articulosNombre,
                      idColor: field.idColor,
                      colorNombre: field.colorNombre,
                      colores: field.colores,
                      precio: field.precio,
                      quantities: {
                        [field.tallaNombre]: {
                          cantidad: field.cantidad,
                          id: field.id,
                        },
                      },
                      total: field.cantidad * field.precio,
                    });
                  } else {
                    acc[key].colorGroups[existingColorIndex].quantities[
                      field.tallaNombre
                    ] = {
                      cantidad: field.cantidad,
                      id: field.id,
                    };
                    acc[key].colorGroups[existingColorIndex].total +=
                      field.cantidad * field.precio;
                  }
                  return acc;
                }, {})
            ).map(([articuloNombre, { articuloInfo, colorGroups }]) => {
              // Calculate totals for this article
              const articleTotals = colorGroups.reduce(
                (totals, group) => {
                  const quantitySum = Object.values(group.quantities).reduce(
                    (sum, q) => sum + (parseFloat(q.cantidad) || 0),
                    0
                  );
                  const priceSum = Object.values(group.quantities).reduce(
                    (sum, q) =>
                      sum + (parseFloat(q.cantidad) || 0) * group.precio,
                    0
                  );

                  return {
                    items: totals.items + quantitySum,
                    price: totals.price + priceSum,
                    singlePrice: group.precio,
                  };
                },
                { items: 0, price: 0 }
              );

              return (
                <div key={articuloNombre} className="mb-8">
                  <div className="d-flex align-items-center border-t-2 border-gray-200 pt-2 pb-2 bg-gray-50">
                    <div className="d-flex align-items-center">
                      <Button
                        size="sm"
                        className="btn mr-3"
                        color="info"
                        onClick={() =>
                          setExpandedTables((prev) => ({
                            ...prev,
                            [articuloNombre]: !prev[articuloNombre],
                          }))
                        }
                      >
                        <i
                          className={`fas fa-chevron-${
                            expandedTables[articuloNombre] ? "up" : "down"
                          }`}
                        ></i>
                      </Button>
                      <h4 className="negrita mb-0 mr-4">{articuloNombre}</h4>
                    </div>
                    {!expandedTables[articuloNombre] && (
                      <div className="d-flex align-items-center">
                        <span
                          className="mr-4 text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          <strong style={{ fontSize: "18px" }}>Piezas:</strong>{" "}
                          {articleTotals.items}
                        </span>
                        <span
                          className="mr-4 text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          <strong style={{ fontSize: "18px" }}>Precio:</strong>{" "}
                          $
                          {articleTotals.singlePrice.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                        <span
                          className="text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          <strong style={{ fontSize: "18px" }}>Total:</strong> $
                          {articleTotals.price.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    )}
                  </div>

                  {expandedTables[articuloNombre] && (
                    <Table borderless>
                      <thead>
                        <tr>
                          <th>Articulo</th>
                          <th>Color</th>
                          {articuloInfo.availableTallas.map((talla) => (
                            <th key={talla} style={{ maxWidth: "60px" }}>
                              {talla}
                            </th>
                          ))}
                          <th style={{ maxWidth: "60px" }}>Precio MEX</th>
                          <th style={{ maxWidth: "80px" }}>Total</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {colorGroups.map((group) => (
                          <tr key={`${group.id}-${group.idColor}`}>
                            {/* Your existing row content */}
                            <td>
                              <Input
                                name="articulo"
                                type="string"
                                placeholder="Articulo"
                                value={group.articulosNombre}
                                disabled
                              />
                            </td>
                            <td>
                              <Input
                                name="idColor"
                                type="select"
                                value={group.idColor}
                                onChange={(event) =>
                                  handleChangeInput(group.id, event)
                                }
                              >
                                <option value="">Selecciona</option>
                                {group.colores?.map((a) => (
                                  <option key={a._id} value={a._id}>
                                    {a.name}
                                  </option>
                                ))}
                              </Input>
                            </td>
                            {articuloInfo.availableTallas.map((talla) => (
                              <td key={talla} style={{ maxWidth: "60px" }}>
                                <Input
                                  name="cantidad"
                                  type="number"
                                  min="0"
                                  step="any"
                                  value={group.quantities[talla]?.cantidad || 0}
                                  onChange={(event) =>
                                    handleChangeInputCantidad(
                                      group.quantities[talla]?.id || group.id,
                                      event
                                    )
                                  }
                                />
                              </td>
                            ))}

                            <td style={{ maxWidth: "60px" }}>
                              <Input
                                name="precio"
                                type="number"
                                min="0"
                                step="any"
                                placeholder="Precio"
                                value={group.precio}
                                required
                                onChange={(event) =>
                                  handleChangeInput(group.id, event)
                                }
                              />
                            </td>
                            <td style={{ maxWidth: "80px" }}>
                              <Input
                                name="total"
                                type="number"
                                min="0"
                                step="any"
                                placeholder="total"
                                value={group.total}
                                disabled
                              />
                            </td>
                            <td>
                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                disabled={inputFields.length === 1}
                                onClick={() => handleRemoveFields(group.id)}
                                tabindex="-1"
                              >
                                <i className="fas fa-minus"></i>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
              );
            })}
          </div>
          {/* </Form> */}
          {/* Termina Tabla Articulos */}

          <br />
          <Row className="align-items-center mt-3">
            <Col xs={3} className="text-dark" style={{ fontSize: "20px" }}>
              <span className="fw-bold">
                <b>Total Piezas:</b>{" "}
              </span>
              <span>
                {new Intl.NumberFormat("en-US").format(total_cantidad)}
              </span>
            </Col>

            <Col xs={3} className="text-dark" style={{ fontSize: "20px" }}>
              <span className="fw-bold">
                <b>Total:</b>{" "}
              </span>
              <span>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "MEX",
                  maximumFractionDigits: 2,
                }).format(total_general)}
              </span>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={1}>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabindex="-1"
                  onClick={savePedido}
                  disabled={total_cantidad == 0 || selectedArea === ""}
                >
                  Guardar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
              )}
            </Col>
            <Col md={1}>
              <Button
                href="/ListadoCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          {/* </Form> */}
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Precio</h4>
            </ModalHeader>
            <ModalBody>
              {mailAutEnviado === false ? (
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={(e) => solicitarAut()}
                  >
                    Solicitar Autorizacion
                  </Button>
                </Col>
              ) : (
                <>
                  <Input
                    bsSize="sm"
                    type="password"
                    placeholder="Password"
                    value={password}
                    required
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <br />
                  <Row>
                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => autorizaCambio()}
                      >
                        Autorizar
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => solicitarAut()}
                      >
                        Reenviar Solicitud
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComprasCreate;
